import { MutableRefObject, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as UserStore from "../../store/user/User";
import TotpFormGroup from "./components/TotpFormGroup";
import SpinnerButton from "../../components/SpinnerButton";
import "../../App.scss";

export interface TotpInputProps {
    onSubmitCallbackRef: MutableRefObject<() => void>;
}

function TotpInput(props: TotpInputProps) {
    const dispatch = useDispatch();
    const isUpdatingAuth =
        useSelector((state: ApplicationState) => state.user?.loginIssueParams?.isUpdatingAuth) ?? false;

    const [totp, setTotp] = useState("");

    if (props.onSubmitCallbackRef?.current) {
        props.onSubmitCallbackRef.current = () => dispatch(UserStore.actionCreators.completeTotpChallenge(totp));
    }

    return (
        <>
            <div className="login-title">Enter verification code</div>

            <div className="login-fields">
                <div style={{ marginTop: "1rem" }}>Input the code generated by your 2FA device</div>
                <TotpFormGroup totp={totp} setTotp={setTotp} />
            </div>

            <div className="login-actions">
                <div style={{ justifySelf: "end" }}>
                    <SpinnerButton
                        className="mt-4"
                        buttonProps={{
                            type: "submit",
                        }}
                        label="Confirm"
                        isLoading={isUpdatingAuth}
                    />
                </div>
            </div>
        </>
    );
}

export default TotpInput;
